import Container from "@/components/ContentContainer/Container";
import InnerContainer from "@/components/ContentContainer/InnerContainer";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Skeleton from "@/components/Skeleton/Skeleton";
import StatusTag from "@/components/StatusTag/StatusTag";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { useParams } from "react-router-dom";
import { useGetConsumable } from "../useConsumables";
import styles from "./ConsumableDetail.module.scss";
import ConsumableDetails from "./ConsumableDetails";
import ConsumableEndOfLife from "./ConsumableEndOfLife";
import ConsumableImpact from "./ConsumableImpact";
import ConsumableRelations from "./ConsumableRelations";
import ConsumableUnitConversion from "./ConsumableUnitConversion";

export default function ConsumableDetail() {
  useTrackOnLoad("Consumable Viewed");

  const { consumableId: id } = useParams();
  const consumableId = Number(id);

  const { data: consumable, isLoading } = useGetConsumable({ consumableId });

  return (
    <div className={styles.ConsumableDetail}>
      <PageHeader
        title={consumable?.name}
        loading={isLoading}
        right={
          <>
            {isLoading ? (
              <Skeleton style={{ width: "90px", height: "24px" }} />
            ) : (
              <StatusTag
                status={consumable?.status || "error"}
                background="white"
              />
            )}
          </>
        }
      />
      <Container
        contentClassName={styles.container}
        padding={false}
      >
        <InnerContainer
          className={styles.left}
          padding={false}
        >
          <InnerContainer title="Details">
            <ConsumableDetails consumableId={consumableId} />
          </InnerContainer>
        </InnerContainer>
        <InnerContainer
          className={styles.right}
          borderLeft={true}
          padding={false}
        >
          <InnerContainer
            title="Impact"
            borderBottom={true}
          >
            <ConsumableImpact consumableId={consumableId} />
          </InnerContainer>
          <InnerContainer
            title="End of life"
            borderBottom={true}
          >
            <ConsumableEndOfLife consumableId={consumableId} />
          </InnerContainer>
          <InnerContainer
            title="Unit conversion"
            borderBottom={true}
          >
            <ConsumableUnitConversion consumableId={consumableId} />
          </InnerContainer>
          <InnerContainer title="Relations">
            <ConsumableRelations consumableId={consumableId} />
          </InnerContainer>
        </InnerContainer>
      </Container>
    </div>
  );
}
